var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingsColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1243_417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 7H8.5C7.94772 7 7.5 7.44772 7.5 8V26C7.5 26.5523 7.94772 27 8.5 27H24.5C25.0523 27 25.5 26.5523 25.5 26V8C25.5 7.44772 25.0523 7 24.5 7Z",
    fill: "#FF5A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 27V30",
    stroke: "#FF5A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 27V30",
    stroke: "#FF5A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11V23",
    stroke: "#FAB73B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11V23",
    stroke: "#FAB73B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11V23",
    stroke: "#FAB73B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7V3C20.5 2.46957 20.2893 1.96086 19.9142 1.58579C19.5391 1.21071 19.0304 1 18.5 1H14.5C13.9696 1 13.4609 1.21071 13.0858 1.58579C12.7107 1.96086 12.5 2.46957 12.5 3V7",
    stroke: "#FAB73B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 7H8.5C7.94772 7 7.5 7.44772 7.5 8V26C7.5 26.5523 7.94772 27 8.5 27H24.5C25.0523 27 25.5 26.5523 25.5 26V8C25.5 7.44772 25.0523 7 24.5 7Z",
    stroke: "#FF5A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1243_417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsColored);
export default __webpack_public_path__ + "static/media/BookingsColored.3e32040fef39a1851c7fe056cb2e8906.svg";
export { ForwardRef as ReactComponent };